"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Transfer = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.812 10.043l-.891 1.901a.32.32 0 00.477.395l3.84-2.775a.4.4 0 00-.234-.724H9.376l-.002.003H4v1.2h4.812zM7.368 5.957l.891-1.901a.32.32 0 00-.477-.395l-3.84 2.775a.4.4 0 00.234.724h2.628v-.003h5.372v-1.2H7.368zM8 16A8 8 0 118 0a8 8 0 010 16z",
  fill: "#ACB3BE"
}));
var _default = exports.default = Transfer;